module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8RGs6"))).then(() => parcelRequire('iDabs'));